import React, { useState } from 'react';
import styled from 'styled-components';
import { QuestionHeader, QuestionIndex, QuestionStatement } from '../../components';
import QuestionContainer from './QuestionContainer';

const ItemsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  > div {
    flex-basis: ${p => p.gab}%;
    text-align: center;
  }
`;

const ScaleItem = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid #f6e9db;
  border-radius: 4px;
  font-family: 'IBM Plex Sans';
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  padding: 16px 24px;
  cursor: pointer;
  background-color: ${p => (p.active ? '#f9a44a' : '#f6e9db')};
  color: ${p => (p.active ? '#ffffff' : '#2e2d29')};
  &[disabled] {
    background-color: #969dab;
    color: #ffffff;
    border-color: #969dab;
    pointer-events: none;
  }
`;

const SensitivityScaleQuestion = ({ index, statement, sensitivityOptions, disabled, onClick }) => {
  const [value, setValue] = useState(null);

  const handleClick = option => {
    setValue(option);
    onClick(option);
  };

  const gab = Math.floor(90 / (sensitivityOptions.length || 1));

  return (
    <QuestionContainer>
      <QuestionHeader>
        <QuestionIndex>{`Question ${index + 1}`}</QuestionIndex>
        <QuestionStatement>{statement}</QuestionStatement>
      </QuestionHeader>
      <div className="my3">
        <ItemsContainer gab={gab}>
          {sensitivityOptions.map((option, i) => (
            <div key={i}>
              <ScaleItem active={value === option} disabled={disabled} onClick={() => handleClick(option)}>
                {option}
              </ScaleItem>
            </div>
          ))}
        </ItemsContainer>
      </div>
    </QuestionContainer>
  );
};

export default SensitivityScaleQuestion;
